import { render, staticRenderFns } from "./addPermissionPossession.vue?vue&type=template&id=29bbd926&"
import script from "./addPermissionPossession.vue?vue&type=script&lang=js&"
export * from "./addPermissionPossession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports